import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, where, limit } from "firebase/firestore";
import { Link } from "react-router-dom";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ProductosRelacionados = ({ titulo, query_data }) => {
  const [data2, setData2] = useState([]);

  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
   
  // console.log({query_data})
  const getData = async () => {
    try {
      setLoading(true);
      const dataRef = collection(db, "productos");
      const q = query(
        dataRef,
        where("categoria", "==", `${query_data}`),
        limit(5)
      );
      //db.collection("Habitaciones").orderBy("fecha_ingreso", "desc").limit(22).onSnapshot((querySnapshot) =>
      //lo de arriba podria usarlo cuando tenga los datos de las fechas de registro
      //para poder poner la data en orden secuencial de los mas nuevos
      const querySnapshot = await getDocs(q);

      const dataDB = querySnapshot.docs.map((doc) => doc.data());
      setData2(dataDB);
    } catch (error) {
      console.log(error);

      setError(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) return <div className='loader'></div>;
  if (error) return <p>{error}</p>;

  return (
    <Container fuid="100%">
      <Row>
        <Col>
          <div id="TituloSecundario">
            <h2>{titulo}</h2>
          </div>
        </Col>
      </Row>
      <Row>
        <div className="producto_section">
          {data2.length > 0 ? (
            data2.map((item) => (
              <Link
                style={{ textDecoration: "none", color: "inherit" }}
                to={`/productos${query_data}/producto/${item.id}`}
              >
                {/* <Link style={{ textDecoration: 'none', color:'inherit'}} to={`producto/${item.id}`}> */}
                <div key={item.id} className="producto_relacionado">
                  <div className="img_prod_relacionado">
                    <img src={item.imagen} alt="producto" />
                  </div>
                  <div className="titulo_prod_relacionado">{item.nombre}</div>
                  <div className="precio_prod_relacionado">
                    <p>
                      {" "}
                      <b>S/.</b>
                      {item.precio}
                    </p>
                  </div>
                </div>
              </Link>
            ))
          ) : (
            <p> No hay productos</p>
          )}
        </div>
      </Row>
    </Container>
  );
};

export default ProductosRelacionados;
